//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import MenuDetail from './MenuDetail.vue'
import MenuItem from './MenuItem.vue'
import MenuMainAction from './MenuMainAction.vue'
import { SUBMENU_REGISTRY } from './SubMenus'
export default {
  components: {
    MenuDetail,
    MenuItem,
    MenuMainAction,
  },
  async fetch() {
    this.projects = await this.getProjects()
    this.$store.commit('setMyProjects', this.projects)
  },
  data() {
    return {
      isOpenDetail: false,
      currentItemId: null,
      submenuProps: {},
      currentSubmenu: null,
      mainItems: [
        {
          id: 'MY_COMPANY',
          label: 'Mi empresa',
          icon: 'office-building-outline',
          path: '/mi-empresa',
          pathMatchs: ['mi-empresa', '/mis-proyectos/inventario-habilidades'],
          submenu: SUBMENU_REGISTRY.BASIC,
          props: {
            elements: [
              {
                id: 'MY_COMPANY-REPORT',
                label: 'Reporte General',
                path: '/mi-empresa',
              },
              {
                ID: 'MY_COMPANY-INVENTORY-SKILLS',
                label: 'Inventario de habilidades',
                path: '/mis-proyectos/inventario-habilidades',
              },
            ],
          },
        },
        {
          id: 'NEW_PROJECT',
          label: 'Crear proyecto',
          icon: 'briefcase-plus-outline',
          path: '/mis-proyectos/nuevo',
          pathMatchs: ['mis-proyectos/nuevo'],
        },
        {
          id: 'MY_PROJECTS',
          label: 'Mis proyectos',
          icon: 'account-box-multiple-outline',
          path: '/mis-proyectos',
          pathMatchs: ['mis-proyectos'],
          submenu: SUBMENU_REGISTRY.PROJECT,
        },
        {
          id: 'MY_WORKERS',
          label: 'Mis trabajadores',
          icon: 'account-group-outline',
          path: '/mis-trabajadores',
          pathMatchs: ['mis-trabajadores'],
        },
      ],
      secondaryItems: [
        {
          id: 'PROFILE',
          label: 'Mi perfil',
          icon: 'account-edit-outline',
          path: '/perfil-empresa',
          pathMatchs: ['perfil-empresa'],
        },
        {
          id: 'SETTINGS',
          label: 'Ajustes',
          icon: 'cog-outline',
          path: '/configuracion',
          pathMatchs: ['configuracion'],
        },
      ],
    }
  },
  computed: {
    currentPathItemId() {
      if (this.currentItemId) return this.currentItemId
      const path = this.$nuxt.$route.path
      const item = [...this.mainItems, ...this.secondaryItems].find((item) =>
        item.pathMatchs.some((pathMatch) => path.includes(pathMatch))
      )
      return item ? item.id : null
    },
    ...mapState(['isOpenMenuMobile']),
  },

  methods: {
    activePath(itemId) {
      return this.currentPathItemId === itemId
    },
    getCurrentItem(itemId) {
      return [...this.mainItems, ...this.secondaryItems].find(
        (item) => item.id === itemId
      )
    },
    getProjects() {
      return this.$repository.project.mine({
        _sort: 'status:DESC',
      })
    },
    handleClickMenuItem(itemId) {
      this.currentItemId = itemId
      const item = this.getCurrentItem(itemId)
      if (item.submenu) {
        this.isOpenDetail = true
        this.currentSubmenu = item.submenu
        this.submenuProps = item.props || {}
      } else {
        this.currentSubmenu = null
        this.submenuProps = {}
        this.isOpenDetail = false
        this.$router.push(item.path)
        this.$store.commit('closeMenuMobile')
      }
    },
  },
}
